import { omit } from 'lodash-es'

import { Transfer } from '@lyrahealth-inc/shared-app-logic/src/models/transfer/Transfer'

import { baseApi, RTKQueryTag } from '../../data/baseApi'

type UpdateTransferPayload = {
  chargeId: string
  patient_lyra_id: string
  status?: string
}

type GetTransfersParams = {
  provider_id: string
  patient_id: string
  status?: string
  appointment_id?: number
  showAlert?: boolean
}

export type GetTransfersResponse = {
  data: Transfer[]
  eligibilityError: boolean
  status: string
}

const transfersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTransfers: builder.query<GetTransfersResponse, GetTransfersParams>({
      query: (params) => ({
        method: 'get',
        url: '/v1/transfers',
        params: {
          provider_id: params.provider_id,
          patient_id: params.patient_id,
          status: params.status,
          appointment_id: params.appointment_id,
        },
        showAlert: params.showAlert ?? true,
      }),
      providesTags: [RTKQueryTag.TRANSFER],
    }),
    updateTransfer: builder.mutation<Transfer, UpdateTransferPayload>({
      query: (transferUpdatePayload) => {
        const transferUpdateFormData = new FormData()

        Object.entries(omit(transferUpdatePayload, 'id')).forEach(([key, value]) => {
          transferUpdateFormData.append(key, value)
        })

        return {
          method: 'put',
          url: `/v1/transfers/${transferUpdatePayload.chargeId}`,
          data: transferUpdateFormData,
        }
      },
      invalidatesTags: [RTKQueryTag.TRANSFER],
    }),
  }),
})

export const { useGetTransfersQuery, useLazyGetTransfersQuery, useUpdateTransferMutation } = transfersApi
